import { shiftModalRoutingService } from 'modals/ShiftModal/ShiftModal.ui.context';
import { useShiftModalDataContext } from 'modals/ShiftModal/ShiftModalProvider.data.context';
import { getConfirmAvailabilityQueryConfig } from 'modals/ShiftModal/src/views/DetailView/ConfirmAvailabilityModal/ConfirmAvailabilityModal.constants';
import { useGQLQuery } from 'hooks';
import { FC, useContext, useMemo } from 'react';
import { FetchOrderCanAssignQuery, FetchOrderCanAssignQueryVariables, Order } from 'types/graphql';
import { createGQLDataContext } from 'utils/createDataContext';

interface ICanAssignValidation {
  validateAndExecute: () => void;
}

export const CanAssignValidationContext = createGQLDataContext<ICanAssignValidation>(
  {} as ICanAssignValidation,
);

export const CanAssignValidationProvider: FC = ({ children }) => {
  const { data } = useShiftModalDataContext();
  const orderRelayId = data?.order?.relayId ?? '';
  const { fetch } = useGQLQuery<
    FetchOrderCanAssignQuery,
    FetchOrderCanAssignQuery,
    FetchOrderCanAssignQueryVariables
  >(
    getConfirmAvailabilityQueryConfig({
      orderId: orderRelayId,
      onSuccess: (responseData: FetchOrderCanAssignQuery) => {
        const order = responseData?.node as Order | null | undefined;
        if (order?.canAssign || order?.canB2bAssign) {
          shiftModalRoutingService.goToView('AssignToAgencyTeamMemberView');
        } else {
          shiftModalRoutingService.goToView('ShiftUnavailableView');
        }
      },
      onError: () => {
        shiftModalRoutingService.goToView('ShiftModalErrorView');
      },
    }),
  );
  const contextValue = useMemo<ICanAssignValidation>(
    () => ({ validateAndExecute: fetch }),
    [fetch],
  );

  return (
    <CanAssignValidationContext.Provider value={contextValue}>
      {children}
    </CanAssignValidationContext.Provider>
  );
};

export const useCanAssignValidationContext = (): ICanAssignValidation =>
  useContext(CanAssignValidationContext);
